import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import BaseAdapter from '../base/BaseAdapter';
import { getShareMessage, urlFormatter, addMetricToObj } from '../../core/utils';
var AlipayMPAdapter = /*#__PURE__*/function (_BaseAdapter) {
  _inherits(AlipayMPAdapter, _BaseAdapter);
  var _super = _createSuper(AlipayMPAdapter);
  function AlipayMPAdapter(_native) {
    var _this;
    _classCallCheck(this, AlipayMPAdapter);
    return _this = _super.call(this, _native, ['https://appx/web-view.min.js', 'https://s1.zhuanstatic.com/common/zzwa/static/js/zzwasdk-v1.4.45.js'], function () {
      _this.zzwa = window.zzwa;
      _this.__sdk = _this.zzwa;
      // WASDK初始化依赖jweixin
      // 由于WASDK是外链，部分魔方页会引用两个adapter，需兼容新adpater调老sdk的情况
      if (_this.__sdk.init) _this.__sdk.init();
    });
  }
  _createClass(AlipayMPAdapter, [{
    key: "asyncIn",
    value: function asyncIn(channel) {
      var cbsucss = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      var cbfail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      typeof channel === 'string' && (channel = [channel]);
      return _get(_getPrototypeOf(AlipayMPAdapter.prototype), "asyncIn", this).call(this, channel, cbsucss, cbfail);
    }
  }, {
    key: "share",
    value: function share() {
      this.zzwa.share(getShareMessage.apply(void 0, arguments));
    }
  }, {
    key: "skipToDetail",
    value: function skipToDetail() {
      var _this2 = this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var newObj = addMetricToObj(args[0]);
      var newArgs = Object.assign([], args, [_objectSpread(_objectSpread({}, args[0]), newObj)]);
      this.agentSkipToDetail(newObj, function () {
        var _this2$zzwa;
        (_this2$zzwa = _this2.zzwa).skipToDetail.apply(_this2$zzwa, _toConsumableArray(newArgs));
      });
    }
  }, {
    key: "skipToOrder",
    value: function skipToOrder() {
      var _this$zzwa;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      var newObj = addMetricToObj(args[0]);
      var newArgs = Object.assign([], args, [_objectSpread(_objectSpread({}, args[0]), newObj)]);
      (_this$zzwa = this.zzwa).skipToOrder.apply(_this$zzwa, _toConsumableArray(newArgs));
    }
  }, {
    key: "skipToUrl",
    value: function () {
      var _skipToUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$zzwa2;
        var _len3,
          args,
          _key3,
          targetUrl,
          formatterArgs,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                for (_len3 = _args.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                  args[_key3] = _args[_key3];
                }
                targetUrl = args[0].targetUrl;
                targetUrl = urlFormatter(targetUrl);
                formatterArgs = Object.assign([], args, [_objectSpread(_objectSpread({}, args[0]), {}, {
                  targetUrl: targetUrl
                })]);
                (_this$zzwa2 = this.zzwa).skipToUrl.apply(_this$zzwa2, _toConsumableArray(formatterArgs));
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function skipToUrl() {
        return _skipToUrl.apply(this, arguments);
      }
      return skipToUrl;
    }()
  }, {
    key: "getMarkLocation",
    value: function getMarkLocation(params) {
      window.wx.openLocation({
        latitude: parseFloat(params.lat),
        // 纬度，浮点数，范围为90 ~ -90
        longitude: parseFloat(params.lon),
        // 经度，浮点数，范围为180 ~ -180。
        name: params.name,
        // 位置名
        address: params.address,
        // 地址详情说明
        scale: 20 // 地图缩放级别,整形值,范围从1~28。默认为最大
      });
    }
  }, {
    key: "registerPageCallback",
    value: function registerPageCallback(callback) {
      if (_typeof(callback) === 'object') {
        callback = callback.callback;
      }
      this.zzwa.onShow(function () {
        callback && callback({
          code: '0',
          msg: '页面显示',
          pageState: '1',
          result: ''
        });
      });
    }
  }]);
  return AlipayMPAdapter;
}(BaseAdapter);
AlipayMPAdapter.pluginName = 'AlipayAdapter';
AlipayMPAdapter.platform = [{
  rule: function rule() {
    return /alipay/i.test(navigator.userAgent);
  },
  name: 'alipay'
}];
export { AlipayMPAdapter as default };